export function Footer() {
  const buildDate = new Date(__BUILD_TIME__).toLocaleString();
  
  return (
    <footer className="bg-white dark:bg-charcoal-800 border-t border-gray-200 dark:border-charcoal-700 py-3 px-6">
      <div className="flex items-center justify-between text-xs text-gray-500 dark:text-warm-sand/50">
        <span>© 2026 Fun 1st Treasures</span>
        <div className="flex items-center gap-3">
          <span className="text-gray-400 dark:text-warm-sand/30" title={buildDate}>
            Built: {buildDate.split(',')[0]}
          </span>
          <span className="font-mono text-gray-500 dark:text-warm-sand/40 bg-gray-100 dark:bg-charcoal-700 px-2 py-0.5 rounded">
            v{__APP_VERSION__}
          </span>
        </div>
      </div>
    </footer>
  );
}
